import * as React from "react";
import { ScaleTime, ScaleLinear } from "d3-scale";
import { line } from "d3-shape";
import { ISample, IDataSequence, SequenceState } from "../Data";

interface Props
{
    xScale: ScaleTime<number, number>;
    yScale: ScaleLinear<number, number>;
    sequence: IDataSequence;
}

// We use D3js to calculate visual properties but React to actually render SVG elemets
export const Line: React.SFC<Props> =({ xScale, yScale, sequence: { color, samples, state, dotted } }) => {
    const getLine = line<ISample>()
        .x(s => xScale(s.x))
        .y(s => yScale(s.y))
    const opacity = state === SequenceState.Dimmed ? 0.5 : 1;
    const width = state === SequenceState.Highlighted ? 2 : 1;
    if(dotted){     
      return <path fill="none" stroke={color} stroke-dasharray="5, 5" x1="10" y1="10" x2="190" y2="10" strokeLinejoin="round" strokeLinecap="round" strokeWidth={width} d={getLine(samples)} opacity={opacity} />;
    }else{
      return <path fill="none" stroke={color} strokeLinejoin="round" strokeLinecap="round" strokeWidth={width} d={getLine(samples)} opacity={opacity} />;
    }
}


// WEBPACK FOOTER //
// ./src/charts/TimeSeries/Line.tsx